﻿import { PrepareMailToLinkRequest } from "@/ServerTypes/PrepareMailToLinkRequest";
import { MailRow } from "@/ServerTypes/TimeTracking";
import { MailGrid } from "@/TimeTracking/Mail/MailGrid";
import { TaskMailDialog } from "@/TimeTracking/Task/TaskMailDialog";
import { Decorators } from "@serenity-is/corelib";


@Decorators.element("<div/>")
@Decorators.registerEditor("Profis.Default.DocumentMailGrid")
export class DocumentMailGrid extends MailGrid {

    protected getColumnsKey() { return "TimeTracking.TaskMail" }
    protected getDialogType() { return TaskMailDialog; }

    private _documentId: number;

    private _subject: string = "";


    get DocumentId(): number {
        return this._documentId;
    }

    set Subject(value: string) {
        this._subject = value;
    }

    set DocumentId(value: number) {
        if (value != this._documentId) {
            this.setEquality(MailRow.Fields.DocumentId, value);
            this._documentId = value;
            this.refresh();
        }
    }

    getInitialTitle() {
        return null;
    }

    getColumns() {
        return super.getColumns().filter(x => x.field != MailRow.Fields.TaskNo);
    }

    getGridCanLoad() {
        return super.getGridCanLoad() && !!this._documentId;
    }

    getPrepareMailToLinkRequest(): PrepareMailToLinkRequest {
        var req = super.getPrepareMailToLinkRequest();
        req.DocumentId = this.DocumentId;
        return req;
    }
}
